import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import DOMPurify from "dompurify";
import { GiPodiumWinner } from "react-icons/gi";
import { MdSportsHandball } from "react-icons/md";
import { IoCarSportSharp } from "react-icons/io5";
import { MdOutlineSportsScore } from "react-icons/md";

import ThemeListIcon1 from "../../img/themes-icon/icon-1.svg";
import ThemeListIcon2 from "../../img/themes-icon/icon-2.svg";
import ThemeListIcon3 from "../../img/themes-icon/icon-3.svg";
import ThemeListIcon4 from "../../img/themes-icon/icon-4.svg";

const EventThemesBase = ({ themesData }) => {

    if (!themesData) return null;

    const { theme_title, theme_subtitle, theme_list } = themesData;

    return (
        <section className="mb-16 md:mb-32">
            <div className="container mx-auto p-4 sm:p-0">
                <ScrollAnimation animateIn="animate__fadeInUp">
                    <h2 className="text-3xl sm:text-4xl lg:text-[50px] text-center uppercase mb-10 md:mb-16
                            font-semibold
                            leading-[1.17647]
                            bg-[linear-gradient(90deg,#C48EEF_0%,#5DABF9_30%,#A1E2DE_70%)]
                            bg-clip-text text-transparent">
                        {theme_title}
                    </h2>
                </ScrollAnimation>

                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6 w-full">
                    {theme_list.map((theme, index) => {
                        let bgGradient, Icon;

                        switch (index) {
                            case 0:
                                bgGradient = "bg-[linear-gradient(90deg,#ADD6FF_0%,#C5E2F4_100%)]";
                                Icon = ThemeListIcon1;
                                break;
                            case 1:
                                bgGradient = "bg-[linear-gradient(90deg,#C5E2F4_0%,#CCEFF5_100%)]";
                                Icon = ThemeListIcon2;
                                break;
                            case 2:
                                bgGradient = "bg-[linear-gradient(270deg,#DEECF5_0%,#CCEFF5_100%)]";
                                Icon = ThemeListIcon3;
                                break;
                            case 3:
                                bgGradient = "bg-[linear-gradient(90deg,#DEECF5_0%,#E8D3F9_100%)]";
                                Icon = ThemeListIcon4;
                                break;
                            default:
                                bgGradient = "bg-white";
                                Icon = null;
                        }

                        return (
                            <ScrollAnimation animateIn="animate__fadeInUp" key={index}>
                                <div className={`flex flex-col p-6 rounded-[26px] ${bgGradient} h-full`}>

                                    {/* Иконка */}
                                    {Icon && (
                                        <div className="w-[75px] h-[75px] md:w-[90px] md:h-[90px] bg-[rgba(0,0,0,0.1)] flex items-center justify-center border border-1 border-[#fff] rounded-full mb-8 md:mb-10">
                                            <img src={Icon} alt="icon" />
                                        </div>
                                    )}

                                    {/* Заголовок */}
                                    <h3
                                        className="font-medium text-[24px] uppercase text-black mb-2"
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(theme.title, { sanitize: true }),
                                        }}
                                    />

                                    {/* Описание */}
                                    <div
                                        className="themes-description font-light text-[18px] text-[#373737]"
                                        dangerouslySetInnerHTML={{
                                            __html: DOMPurify.sanitize(theme.desc, { sanitize: true }),
                                        }}
                                    />
                                </div>
                            </ScrollAnimation>
                        );
                    })}
                </div>

            </div>
        </section>
    )

}

export default EventThemesBase;